import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import { SelectTimeZone } from '../../features/SelectTimeZone/index.js';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField, FormLoading } from '../../shared/ui/FormLayout';

const EditTimezonePage = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!form.title?.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      await apiRequests.events.updateTimezone({ id, offset: form.offset, title: form.title, mainLanguageId: form.mainLanguageId });
      toast.success('Часовая зона изменена');
      navigate('/events/timezones');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  useEffect(() => {
    const getData = () => {
      apiRequests.events.getTimezone(id).then((res) => {
        setForm(res);
      });
    };
    getData();
  }, []);

  if (!form) return <FormLoading />;

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/events/timezones')} saving={saving} submitText="Сохранить">
      <FormSection title="Основная информация">
        <Row>
          <Col md={4}>
            <FormField label="Заголовок" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} />
            </FormField>
          </Col>
          <Col md={4}>
            <FormField label="UTC">
              <SelectTimeZone initialValue={form.offset} onSelect={(val) => setForm((prev) => ({ ...prev, offset: val }))} />
            </FormField>
          </Col>
          <Col md={4}>
            <LanguageOptions initialValue={form.mainLanguageId} onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
          </Col>
        </Row>
      </FormSection>
    </FormLayout>
  );
};

export default EditTimezonePage;
